import React from 'react';

import { Paper, TablePagination } from '@material-ui/core';
import styled from 'styled-components';
import { StyledBox } from 'styles/common';

import { ReviewMiniIcon } from 'constants/icons';
import {
  sendClickedNextCompletedReviewsEvent,
  sendClickedNextPendingReviewsEvent,
  sendClickedPreviousCompletedReviewsEvent,
  sendClickedPreviousPendingReviewsEvent,
} from 'constants/mixpanelHelper';

import { showErrorMessage, showLoader, showNoData } from '../../components/common';
import PeerAlertRowDisplay from './PeerAlertRowDisplay';
import ReviewRowDisplay from './ReviewRowDisplay';
import SectionHeader from './SectionHeader';

const StyledTablePagination = styled(TablePagination)`
  padding: 0.5rem 1.5rem !important;
`;

const ReviewsList = ({
  title,
  loading,
  reviewList,
  removeFromReviewsList,
  updatePeerStatus,
  currentPage,
  count,
  limit,
  setCurrentPage,
  errorMessage,
  noDataMessage,
  showDateColumn = true,
  resetData,
  loggedInEmployee,
  info = null,
  className = '',
}) => {
  const isCompletedReviews = title === 'Completed Reviews';
  return (
    <StyledBox className={className} bottomGutter={4} style={{ position: 'relative' }}>
      <Paper>
        <SectionHeader icon={<ReviewMiniIcon />} title={title} info={info} />
        {loading && showLoader()}
        {!loading && reviewList === null && showErrorMessage({ errorText: errorMessage })}
        {!loading &&
          reviewList !== null &&
          (reviewList.length === 0 ? (
            showNoData({ infoText: noDataMessage })
          ) : (
            <>
              {reviewList &&
                reviewList.length > 0 &&
                reviewList.map(({ employee, review, endDateFormatted, message, startDate }, index) =>
                  message ? (
                    <PeerAlertRowDisplay message={message} feedbackForm={review.feedbackForm} />
                  ) : (
                    <ReviewRowDisplay
                      review={review}
                      employee={employee}
                      endDateFormatted={endDateFormatted}
                      startDate={startDate}
                      removeFromReviewsList={removeFromReviewsList}
                      updatePeerStatus={updatePeerStatus}
                      showDateColumn={showDateColumn}
                      // eslint-disable-next-line react/no-array-index-key
                      key={index}
                      resetData={resetData}
                      loggedInEmployee={loggedInEmployee}
                      isCompletedReviewRow={isCompletedReviews}
                    />
                  )
                )}
              <StyledTablePagination
                component="div"
                count={count}
                rowsPerPage={limit}
                rowsPerPageOptions={[]}
                page={currentPage}
                onChangePage={(e, newPage) => {
                  if (newPage <= currentPage) {
                    if (isCompletedReviews) {
                      sendClickedPreviousCompletedReviewsEvent({
                        eventProperties: {
                          source: 'reviews',
                        },
                      });
                    } else {
                      sendClickedPreviousPendingReviewsEvent({
                        eventProperties: {
                          source: 'reviews',
                        },
                      });
                    }
                  } else if (isCompletedReviews) {
                    sendClickedNextCompletedReviewsEvent({
                      eventProperties: {
                        source: 'reviews',
                      },
                    });
                  } else {
                    sendClickedNextPendingReviewsEvent({
                      eventProperties: {
                        source: 'reviews',
                      },
                    });
                  }
                  setCurrentPage(newPage);
                }}
                labelRowsPerPage={null}
              />
            </>
          ))}
      </Paper>
    </StyledBox>
  );
};

export default ReviewsList;
